import React from "react";

export default function Panel({ children, className = "" }) {
  return (
    <div
      className={`bg-gradient-to-b from-neutral-900 to-neutral-950 border border-neutral-800 rounded-md px-3 py-2 shadow-inner ${className}`}
    >
      {children}
    </div>
  );
}
